import { createSelector } from 'reselect';
import { specialtiesDataSelector } from 'store/providerSearch/facets/selectors';
import {
  locationSuggestionsDataSelector,
  providerSuggestionsDataSelector
} from 'store/providerSearch/providerSuggestions/selectors';
import {
  locationsResponseDTO,
  providerSuggestionsResponseDTO,
  specialtiesResponseDTO
} from './mappers';

export const searchSuggestionsDataSelector = createSelector(
  specialtiesDataSelector,
  providerSuggestionsDataSelector,
  locationSuggestionsDataSelector,
  (specialties, providerSuggestions, locations) => [
    ...providerSuggestionsResponseDTO(providerSuggestions),
    ...specialtiesResponseDTO(specialties),
    ...locationsResponseDTO(locations)
  ]
);
